import React, { useState, useRef, useEffect } from "react"
import { NavLink, Link } from "react-router-dom"
import users from "../images/Logout.svg"
import Logo from "../images/Logo_new.svg"
import { signOut } from "firebase/auth"
import { auth } from "../../Firebase/config"
import { useNavigate } from "react-router-dom"
import Notify from "../Componentslogic/Usenotifications"
import Lottie from "lottie-react"
import menuAnimationData from "../images/Lottie-anim/menuV2.json"
import "../../Styles/SideMenuStyles.css"

export const SidemenuComponent = () => {
  const navigate = useNavigate()
  const lottieRef = useRef(null)

  // ✅ State for opening/closing menu
  const [isOpen, setIsOpen] = useState(false)
  const [direction, setDirection] = useState(1)

  // ✅ State for submenus
  const [isOrdersOpen, setIsOrdersOpen] = useState(false)
  const [isInventoryOpen, setIsInventoryOpen] = useState(false)
  const [isEngagementsOpen, setIsEngagementsOpen] = useState(false)
  const [isOverviewOpen, setIsOverviewOpen] = useState(false)

  // ✅ Logout function
  const Logout = () => {
    signOut(auth)
      .then(() => {
        Notify("Signed out", "success")
        navigate("/login")
        localStorage.removeItem("user")
      })
      .catch((error) => {
        console.error("Logout error:", error)
      })
  }

  // ✅ Toggle Main Menu
  const toggleMenu = () => {
    setIsOpen(!isOpen)
    setDirection(direction === 1 ? -1 : 1)

    if (lottieRef.current) {
      lottieRef.current.setDirection(direction)
      lottieRef.current.setSpeed(4)
      lottieRef.current.play()
    }
  }

  // ✅ Toggle Submenus
  const toggleOrders = () => setIsOrdersOpen(!isOrdersOpen)
  const toggleInventory = () => setIsInventoryOpen(!isInventoryOpen)
  const toggleEngagements = () => setIsEngagementsOpen(!isEngagementsOpen)
  const toggleOverview = () => setIsOverviewOpen(!isOverviewOpen)

  // ✅ Handle Active Link
  const activeLink = ({ isActive }) => (isActive ? "Active" : "")

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.goToAndStop(0, true)
    }
  }, [])

  return (
    <>
      {/* Menu Toggle Button */}
      <div onClick={toggleMenu} className="hamburger-icon">
        <Lottie
          lottieRef={lottieRef}
          animationData={menuAnimationData}
          loop={false}
          style={{ width: 50, height: 50, cursor: "pointer" }}
        />
      </div>

      {/* Sidebar Menu */}
      <div className={`sidemenu ${isOpen ? "open" : ""}`}>
        <div className="d-flex justify-content-center">
          <img className="logo mb-3" alt="Katalyst" src={Logo} />
        </div>
        <div className="section-title">MENU</div>

        {/* Overview Section */}
        <div onClick={toggleOverview}>
          <Link style={{ textDecoration: "none", color: "black" }}>
            <p>Overview</p>
          </Link>
        </div>
        {isOverviewOpen && (
          <div className="submenu">
            <NavLink to="/adminOverview" className={activeLink}>
              <p> Dine-in </p>
            </NavLink>
            <NavLink to="/admindeliveryOverview" className={activeLink}>
              <p> Delivery </p>
            </NavLink>
          </div>
        )}

        {/* Orders Section */}
        <div onClick={toggleEngagements}>
          <Link style={{ textDecoration: "none", color: "black" }}>
            <p>Orders</p>
          </Link>
        </div>
        {isEngagementsOpen && (
          <div className="submenu">
            <NavLink to="/DineInorders" className={activeLink}>
              <p> Dine-in </p>
            </NavLink>
            <NavLink to="/Deliveryorders" className={activeLink}>
              <p> Delivery </p>
            </NavLink>
          </div>
        )}

        {/* All Products */}
        <NavLink className={activeLink} to="/adminmanagement">
          <p> All Products</p>
        </NavLink>
        <NavLink className={activeLink} to="/CatgoriesPlacement">
          <p> Menu Placement</p>
        </NavLink>

        {/* Customers Section */}
        <div onClick={toggleOrders}>
          <Link style={{ textDecoration: "none", color: "black" }}>
            <p>Customers </p>
          </Link>
        </div>
        {isOrdersOpen && (
          <div className="submenu">
            <NavLink to="/admindineinusers" className={activeLink}>
              <p> Dine-in </p>
            </NavLink>
            <NavLink to="/admindeliveryusers" className={activeLink}>
              <p> Delivery </p>
            </NavLink>
          </div>
        )}

        {/* Engagements Section */}
        <div onClick={toggleInventory}>
          <Link style={{ textDecoration: "none", color: "black" }}>
            <p>Engagements </p>
          </Link>
        </div>
        {isInventoryOpen && (
          <div className="submenu">
            <NavLink to="/allreviews" className={activeLink}>
              <p>Reviews</p>
            </NavLink>
            <NavLink to="/adminNotify" className={activeLink}>
              <p>Set-Notification</p>
            </NavLink>

            <NavLink to="/Allcodes" className={activeLink}>
              <p>Promocodes</p>
            </NavLink>
          </div>
        )}

        {/* Accounts */}
        <NavLink to="/adminaccounts" className={activeLink}>
          <p>Accounts</p>
        </NavLink>

        {/* Logout Section */}
        <div className="logout-section">
          <div className="d-flex align-items-center">
            <img className="icon mb-3" src={users} alt="Manage" />
            <p
              className="btns-Admin"
              onClick={Logout}
              style={{ color: "white" }}
            >
              <b>Logout</b>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
